import { useCallback } from "react";

const useUniversalTipTapMenuBar = ({
  editor,
  className,
  setShowLinkModal,
  menubarActionSize = "20px",
  showTextActions,
  showBulletLists,
  showLink,
  showHeadingActions,
}) => {
  const showLinkModal = useCallback(() => {
    setShowLinkModal(true);
  }, [setShowLinkModal]);

  const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;

  const checkIfActiveOrNot = useCallback(
    (menuType, levelOfMenuType) => {
      return `${
        editor?.isActive(menuType, levelOfMenuType) ? "#4652b7" : "#807e7e"
      }`;
    },
    [editor]
  );

  return {
    editor,
    className,
    showLinkModal,
    isMac,
    checkIfActiveOrNot,
    menubarActionSize,
    showTextActions,
    showBulletLists,
    showLink,
    showHeadingActions,
  };
};

export default useUniversalTipTapMenuBar;
